import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ON_FORM_CHANGE, SET_API_DATA, SET_ERROR } from "../redux/constants";
import { getSlug, setErrors, toggleModelShow } from "../shared/CustomFunc";
import { checkValid } from "../shared/validation";
import { ApiContainer } from "../utils/api";
import { assessmentIds } from "../utils/constant";

export const assessmentsViewContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { api } = ApiContainer();
  const selectGenderFormPath = { parent: "selectGenderData" };
  const apiState = useSelector((state) => state?.api);
  const assessmentListLoader = useSelector(
    (state) => state?.api?.loader?.assessmentList
  );
  const assessmentListForTakeAssessment = useSelector(
    (state) => state?.api?.assessmentListForTakeAssessment
  );

  const location = useLocation();
  const markerInfo = useSelector((state) => state?.api?.markerInfo);
  const userRoleData = useSelector((state) => state.app.userData);
  const allAssessmentResults = useSelector(
    (state) => state?.api?.assessmentResult
  );

  const { form } = useSelector((state) => state);
  const { formData, formErrors } = form;
  const selectGenderInfo = formData?.[selectGenderFormPath.parent];
  const selectGenderInfoError = formErrors?.[selectGenderFormPath.parent];

  const [resultInfo, setResultInfo] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const getAssessments = async () => {
    const keyword =
      !apiState?.tabs?.assessmentTab || apiState?.tabs?.assessmentTab === "all"
        ? ""
        : apiState?.tabs?.assessmentTab;

    const filterKeyword = apiState?.tabs?.assessmentFilterTab;
    const assessmentListResponse = await api({
      method: "GET",
      endPoint: `assessment/list${
        filterKeyword ? `?assessment_type=${filterKeyword}` : ""
      }${keyword ? `${filterKeyword ? "&" : "?"}key_word=${keyword}` : ""}`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "assessmentList",
    });
    if (assessmentListResponse) {
      const filteredArray = assessmentListResponse?.data?.assessments?.filter(
        ({ assessment_taken }) => !assessment_taken
      );
      const updatedAssessmentList = assessmentListForTakeAssessment?.map(
        (item) => {
          return (
            filteredArray?.find(
              (ele) =>
                ele &&
                ele?.assessment_id === item?.assessment_id &&
                !ele?.assessment_taken &&
                item.assessment_taken
            ) || item
          );
        }
      );
      dispatch({
        type: SET_API_DATA,
        payload: {
          assessmentListForTakeAssessment:
            updatedAssessmentList || assessmentListResponse?.data?.assessments,
          assessmentList:
            assessmentListResponse?.data?.message === "No data found"
              ? []
              : assessmentListResponse?.data?.assessments || [],
          isWaiverSigned: assessmentListResponse?.data?.is_waiver_signed,
        },
      });
    }
  };

  useEffect(() => {
    dispatch({
      type: SET_API_DATA,
      payload: {
        assessmentList: [],
      },
    });

    if (apiState?.tabs?.assessmentTab) {
      const timeId = setTimeout(() => {
        getAssessments();
      }, 200);
      return () => clearTimeout(timeId);
    }
    return () => {};
  }, [apiState?.tabs?.assessmentTab, apiState?.tabs?.assessmentFilterTab]);

  useEffect(() => {
    dispatch({
      type: SET_API_DATA,
      payload: {
        tabs: {
          ...apiState?.tabs,
          assessmentTab:
            location?.state?.status === "completed" ? "completed" : "all",
        },
      },
    });
    navigate("/assessments");
    return () => {
      dispatch({
        type: SET_API_DATA,
        payload: {
          tabs: {
            ...apiState?.tabs,
            assessmentTab: "all",
          },
        },
      });
    };
  }, []);

  useEffect(() => {
    const result = apiState?.assessmentList?.length
      ? apiState?.assessmentList?.find(
          (el) => el?.name === "Vasana Type Assessment"
        )?.result
      : null;
    if (result) {
      setResultInfo({ ...markerInfo?.[result?.toLowerCase()] });
    }
  }, [apiState?.assessmentList]);

  const handleTabChange = (value) => {
    dispatch({
      type: SET_API_DATA,
      payload: {
        tabs: {
          ...apiState?.tabs,
          assessmentTab: value,
        },
      },
    });
  };
  const onFilterChange = (e) => {
    dispatch({
      type: SET_API_DATA,
      payload: {
        tabs: {
          ...apiState?.tabs,
          assessmentFilterTab: e?.target?.value,
        },
      },
    });
  };

  const handleButtonClick = (name, assessmentId, type, submissionId) => {
    localStorage.setItem("currentAssessmentId", assessmentId);
    if (
      (name.includes("Hormone Health Assessment") ||
        name.includes("Medical History Questionnaire")) &&
      userRoleData?.user_profile?.gender !== "Male" &&
      userRoleData?.user_profile?.gender !== "Female"
    ) {
      if (!name.includes("male")) {
        dispatch(toggleModelShow("GenderChangeModal"));
      } else {
        const slug = getSlug(apiState?.assessmentList, assessmentId);
        navigate(`/get-started/${slug}`);
      }
      return;
    }
    if (submissionId) {
      navigate(`/assessments/${assessmentId}`);
    } else {
      const slug = getSlug(apiState?.assessmentList, assessmentId);
      navigate(`/get-started/${slug}`);
    }
  };

  const retakeAssessment = (assessmentId, type, name) => {
    localStorage.setItem("currentAssessmentId", assessmentId);
    if (
      (name.includes("Hormone Health Assessment") ||
        name.includes("Medical History Questionnaire")) &&
      userRoleData?.user_profile?.gender !== "Male" &&
      userRoleData?.user_profile?.gender !== "Female"
    ) {
      if (!name.includes("male")) {
        dispatch(toggleModelShow("GenderChangeModal"));
      } else {
        const slug = getSlug(apiState?.assessmentList, assessmentId);
        navigate(`/get-started/${slug}`);
      }
      dispatch({
        type: SET_API_DATA,
        payload: {
          ...(assessmentId === assessmentIds.vasanaType
            ? { downloadVasanaTypeReport: null }
            : assessmentId === assessmentIds.introExtro
            ? { downloadIntroExtroReport: null }
            : {}),
          assessmentResult: { ...allAssessmentResults, [assessmentId]: null },
        },
      });
      return;
    }
    localStorage.setItem("currentAssessmentId", assessmentId);
    const slug = getSlug(apiState?.assessmentList, assessmentId);
    navigate(`/get-started/${slug}`);
  };

  const genderOption = [
    { key: "Male", value: "male" },
    { key: "Female", value: "female" },
  ];

  const selectGenderFields = {
    data: [
      {
        question: "Select Gender",
        description:
          "To continue with the Hormone Health Assessment, please provide your gender as assigned at birth.",
        value: [
          {
            control: "select",
            label: "Gender",
            name: "gender",
            value: 0,
            validateAs: "selectMenu",
            isRequired: true,
            fullWidth: true,
            placeHolder: "Select gender",
            errorMessage: "please select any gender",
            options: genderOption,
            md: 6,
            variant: "standard",
          },
        ],
      },
    ],
  };

  const handleSelectGender = async () => {
    let errors = {};
    selectGenderFields?.data?.forEach((item) => {
      Object.values(item.value)?.forEach((control) => {
        const { name, validateAs, label } = control;
        errors = {
          ...errors,
          [name]: validateAs
            ? checkValid({
                validateAs,
                name,
                value: selectGenderInfo?.[name],
                label,
              })
            : false,
        };

        dispatch({
          type: SET_ERROR,
          payload: {
            formErrors: {
              ...form.formErrors,
              [selectGenderFormPath.parent]: { ...errors },
            },
          },
        });
      });
    });
    if (selectGenderInfo?.gender) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          SelectedGender: selectGenderInfo?.gender,
        },
      });
      localStorage.setItem("gender", selectGenderInfo?.gender);
      const slug = getSlug(apiState?.assessmentList, 22);
      navigate(`/get-started/${slug}`);
      dispatch(toggleModelShow("GenderChangeModal"));
    }
  };

  const setGenderData = (name, value) => {
    dispatch(
      setErrors({
        errors: selectGenderInfoError ?? {},
        value,
        name,
        formPath: selectGenderFormPath,
      })
    );
    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...form.formData,
          [selectGenderFormPath.parent]: {
            ...selectGenderInfo,
            [name]: value,
          },
        },
      },
    });
  };

  const handelGenderChange = (e) => {
    const { name, value } = e.target;
    setGenderData(name, value);
  };

  const ButtonsForGender = [
    {
      label: "Save",
      handleClick: handleSelectGender,
      hasLoader: true,
      disabled: false,
    },
  ];

  useEffect(() => {
    if (searchParams.get("type")) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          assessmentList: [],
          tabs: {
            ...apiState?.tabs,
            assessmentTab: "all",
            assessmentFilterTab: searchParams.get("type"),
          },
        },
      });
    }
  }, [searchParams]);

  return {
    assessmentTab: apiState?.tabs?.assessmentTab,
    assessmentFilterTab: apiState?.tabs?.assessmentFilterTab,
    handleTabChange,
    assessmentList: apiState?.assessmentList,
    isWaiverSigned: apiState?.isWaiverSigned,
    assessmentListLoader,
    resultInfo,
    handleButtonClick,
    retakeAssessment,
    userRoleData,
    onFilterChange,
    ButtonsForGender,
    selectGenderFields,
    handleSelectGender,
    handelGenderChange,
    selectGenderInfo,
    selectGenderInfoError,
  };
};
